const initialState = {
  venueList: [],
  cityList: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_VENUE_LIST:VENUE_LIST:SET':
    return {
      ...state,
      venueList: data,
    };
  case 'ADMIN_VENUE_LIST:CITY_LIST:SET':
    return {
      ...state,
      cityList: data,
    };
  default:
    return state;
  }
}